'use strict'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { functor } from 'react-stockcharts/lib/utils'

class SvgPathAnnotation extends Component {
  state = {
    popup: null
  }
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
  componentDidMount() {
    document.addEventListener('scroll', this.hidePopup)
  }
  componentWillUnmount() {
    this.hidePopup()
    document.removeEventListener('scroll', this.hidePopup)
  }
  handleClick(e) {
    const { onClick } = this.props

    if (onClick) {
      const { xScale, yScale, datum } = this.props
      onClick({ xScale, yScale, datum }, e)
    }
  }
  showPopup = (tooltip) => {
    if (this.state.popup) {
      this.state.popup.remove()
    }
    const popup = document.createElement('div')
    const rect = this.g.getBoundingClientRect()
    const left = rect.left + window.scrollX
    const top = rect.top + window.scrollY + 30
    this.setState({popup:popup})
    popup.classList.add(this.props.tooltipClassName)
    popup.style.position = 'absolute'
    popup.style.left = left+'px'
    popup.style.top = top+'px'
    tooltip.map(t => {
      const line = document.createElement('p')

      const label = document.createElement('span')
      label.innerHTML = t.value !== undefined ? t.label + ': ' : t.label
      line.appendChild(label)

      if (t.value !== undefined) {
        const value = document.createElement('b')
        value.innerHTML = t.value
        line.appendChild(value)
      }

      popup.appendChild(line)
    })
    document.body.appendChild(popup)
  }
  hidePopup = () => {
    if (this.state.popup) {
      this.state.popup.classList.add('leave')
      setTimeout(() => {
        if (this.state.popup) {
          this.state.popup.remove()
        }
      },300)
    }
  }
  render() {
    const { className, opacity } = this.props
    const { xAccessor, xScale, yScale, path } = this.props

    const { x, y, fill, stroke, tooltip } = helper(this.props, xAccessor, xScale, yScale)

    return (<g
      ref={el => this.g = el}
      className={className}
      onClick={this.handleClick}
      onMouseEnter={() => this.showPopup(tooltip)}
      onMouseLeave={() => this.hidePopup()}
    >
      <path d={path({ x, y })} stroke={stroke} fill={fill} opacity={opacity} />
    </g>)
  }
}

function helper(props, xAccessor, xScale, yScale) {
  const { x, y, datum, fill, stroke, tooltip, plotData } = props

  const xFunc = functor(x)
  const yFunc = functor(y)

  const [xPos, yPos] = [xFunc({ xScale, xAccessor, datum, plotData }), yFunc({ yScale, datum, plotData })]

  return {
    x: xPos,
    y: yPos,
    fill: functor(fill)(datum),
    stroke: functor(stroke)(datum),
    tooltip: functor(tooltip)(datum),
  }
}

SvgPathAnnotation.propTypes = {
  className: PropTypes.string,
  tooltipClassName: PropTypes.string,
  path: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  xAccessor: PropTypes.func,
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  datum: PropTypes.object,
  stroke: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  opacity: PropTypes.number,
  text: PropTypes.string
}

SvgPathAnnotation.defaultProps = {
  className: 'react-stockcharts-svgpathannotation',
  opacity: 1,
  x: ({ xScale, xAccessor, datum }) => xScale(xAccessor(datum)),
}

export default SvgPathAnnotation
